module.exports = __webpack_public_path__ + "static/media/landing_time.993da973.svg";